(function () {
  /**
     * Menu Toggle Behaviors
     *
     * @param {string} id - The ID.
     */
  var navMenu = function (id) {
    var wrapper = document.body
    // this is the element to which a CSS class is added when a mobile nav menu is open

    var mobileButton = document.getElementById(id + '-mobile-menu')

    var navWrapper = document.querySelector('.' + id + '-navigation')

    if (mobileButton) {
      mobileButton.onclick = function () {
        wrapper.classList.toggle(id + '-navigation-open')
        toggleAriaExpanded(mobileButton)
        mobileButton.focus()
      }
    }

    function toggleAriaExpanded (el, withListeners) {
      if (el.getAttribute('aria-expanded') !== 'true') {
        el.setAttribute('aria-expanded', 'true')
        if (withListeners) {
          document.addEventListener('click', collapseMenuOnClickOutside)
        }
      } else {
        el.setAttribute('aria-expanded', 'false')
        if (withListeners) {
          document.removeEventListener('click', collapseMenuOnClickOutside)
        }
      }
    }

    function collapseMenuOnClickOutside (event) {
      if (!document.getElementById('site-navigation').contains(event.target)) {
        var buttons = Array.prototype.slice.call(document.getElementById('site-navigation').querySelectorAll('.sub-menu-toggle'))
        buttons.forEach(function (button) {
          button.setAttribute('aria-expanded', 'false')
        })
      }
    }

    function expandSubMenu (el) {
      // Close other expanded items.
      var buttons = Array.prototype.slice.call(el.closest('nav').querySelectorAll('.sub-menu-toggle'))
      buttons.forEach(function (button) {
        if (button !== el) {
          button.setAttribute('aria-expanded', 'false')
        }
      })

      // Toggle aria-expanded on the button.
      toggleAriaExpanded(el, true)

      // On tab-away collapse the menu.
      var linkEls = Array.prototype.slice.call(el.parentNode.querySelectorAll('ul > li:last-child > a'))
      linkEls.forEach(function (linkEl) {
        linkEl.addEventListener('blur', function (event) {
          if (!el.parentNode.contains(event.relatedTarget)) {
            el.setAttribute('aria-expanded', 'false')
          }
        })
      })
    }

    navWrapper.addEventListener('click', function (event) {
      var button = event.target.closest('button')

      if (!button) return

      if (!navWrapper.contains(button)) return

      if (button.className === 'sub-menu-toggle') {
        expandSubMenu(button)
      }
    })

    var lis = Array.prototype.slice.call(document.getElementById('site-navigation').querySelectorAll('.v2c-header__navigation > .menu-item-has-children'))
    lis.forEach(function (li) {
      li.addEventListener('mouseenter', function () {
        this.querySelector('.sub-menu-toggle').setAttribute('aria-expanded', 'true')
      })
      li.addEventListener('mouseleave', function () {
        this.querySelector('.sub-menu-toggle').setAttribute('aria-expanded', 'false')
      })
    })
  }

  window.addEventListener('load', function () {
    navMenu('header')
  })
}())
